 

<img src= {{projectImage.imageContent}} alt="Click to expand" width="100%"/>